import React, { useEffect, useState } from "react";

export default function DayDateCards({ neonColor = "#0f0" }) {
  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    // Update every minute in case day/date changes at midnight
    const interval = setInterval(() => setCurrentDate(new Date()), 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const day = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const date = currentDate.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

  return (
    <div
      style={{
        display: "flex",
        gap: "1rem",
        justifyContent: "center",
        flexWrap: "wrap",
        marginBottom: "2rem",
      }}
    >
      <div
        style={{
          background: "#111",
          padding: "1rem",
          borderRadius: "10px",
          minWidth: "140px",
          textAlign: "center",
          boxShadow: `0 0 8px ${neonColor}, 0 0 16px ${neonColor}`,
          color: neonColor,
        }}
      >
        <div style={{ fontSize: "3.4rem", marginTop: "0.2rem", textTransform: "uppercase" }}>{day}</div>
      </div>

      <div
        style={{
          background: "#111",
          padding: "1rem",
          borderRadius: "10px",
          minWidth: "140px",
          textAlign: "center",
          boxShadow: `0 0 8px ${neonColor}, 0 0 16px ${neonColor}`,
          color: neonColor,
        }}
      >
        <div style={{ fontSize: "4.4rem", marginTop: "0.2rem", textTransform: "uppercase" }}>{date}</div>
      </div>
    </div>
  );
}
